import * as React from 'react';

import {Button} from 'shells/button/button';
import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {NavButtons, RightFrame, ModalMain} from 'shells/modal/step-modal/layout';
import {SpacerGroup} from 'shells/spacer/spacer-group';
import {ModalHeader} from 'shells/typography/modal-header';
import {ModalSubheader} from 'shells/typography/modal-subheader';

import type {SmtpPortType} from 'nutshell-graphql-types';

import {SmtpForm} from '../../smtp/smtp-form';
import type {ExposedSubform} from '../../smtp/smtp-form';
import {SubmitSmtp} from '../../smtp/submit-smtp';

import {trackModalPageLoad} from '../track-page-load';

type Props = {
    onCancel: () => void;
    onSuccess: () => void;
    onVerificationTimeout: () => void;
    userEmailId: string;
    hostname: string;
    password: string;
    port: string;
    portType: SmtpPortType;
    username: string;
    currentUrl: string;
};

export function SmtpFailure(props: Props) {
    const formRef = React.useRef<ExposedSubform | null | undefined>({handleSubmit: () => {}});
    const [errorMessage, setErrorMessage] = React.useState<string | null | undefined>(null);

    React.useEffect(() => {
        trackModalPageLoad(props.currentUrl);
    }, [props.currentUrl]);

    function subformSubmit() {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    }

    return (
        <RightFrame>
            <ModalMain>
                <ModalHeader>We weren’t able to verify your settings</ModalHeader>
                <ModalSubheader>Double-check your settings and try again.</ModalSubheader>
                {errorMessage ? (
                    <SpacerGroup>
                        <FlashBanner hasBorder={true} type='error'>
                            {errorMessage}
                        </FlashBanner>
                    </SpacerGroup>
                ) : null}
                <SubmitSmtp
                    onVerificationTimeout={props.onVerificationTimeout}
                    onVerificationSuccess={props.onSuccess}
                    onVerificationFailure={() => {
                        setErrorMessage('Unable to connect, please try again.');
                    }}
                    onError={(msg) => {
                        setErrorMessage(msg || 'Unable to connect, please try again.');
                    }}
                >
                    {({updateAndTest, inProgress}) => {
                        // @ts-expect-error
                        function submitForm(newSettings) {
                            updateAndTest(newSettings);
                        }

                        return (
                            <SmtpForm
                                disabled={inProgress}
                                // @ts-expect-error
                                ref={formRef}
                                userEmailId={props.userEmailId}
                                hostname={props.hostname}
                                password={props.password}
                                port={props.port}
                                portType={props.portType}
                                username={props.username}
                                // @ts-expect-error
                                onSubmit={(newSettings) => {
                                    setErrorMessage(null);
                                    submitForm(newSettings);
                                }}
                            />
                        );
                    }}
                </SubmitSmtp>
            </ModalMain>
            <NavButtons>
                <React.Fragment>
                    <Button variant='text' onClick={props.onCancel}>
                        Set up later
                    </Button>
                    <Button variant='primary' size='big' onClick={subformSubmit}>
                        Try again
                    </Button>
                </React.Fragment>
            </NavButtons>
        </RightFrame>
    );
}
